module.exports = __webpack_public_path__ + "media/bootstrap-icons/clock-history-62d8e63e.svg";